

import { useDispatch } from 'react-redux';

import { useTypedSelector } from '../../../../../../../hooks/useTypeSelector';

import {

    getGuiSettings,
    saveGuiSettings,
    deleteGuiSettings

} from '../../../../../../../store';

import DragManager from '../../../../../../../com/dragManager/DragManager'

import GuiThemeSettingsPopup from './guiThemeSettings/GuiThemeSettingsPopup'

import GuiThemesTable from './table/GuiThemesTable'

import GuiThemesHeader, { IGuiThemesHeaderRef } from './header/GuiThemesHeader'

import './GuiThemesPopup.scss'
import { useEffect, useRef, useState } from 'react'
import {FileDto, GuiSettingsDto} from '../../../../../../../dtos';

interface IGuiThemesPopup {
    show: boolean;
    onHide: () => void;
}

const GuiThemesPopup: React.FC<IGuiThemesPopup> = (props) => {

    const dispatch = useDispatch();
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let guiSettingsState = useTypedSelector((state) => state.guiSettings);

    const [showSettingsPopup, setShowSettingsPopup] = useState(false)

    const [currentGuiSettingDto, setCurrentGuiSettingDto] = useState<GuiSettingsDto>(guiSettingsState.currentGuiSettingsDto)

    const contentRef = useRef<HTMLDivElement>(null)
    const headerRef = useRef<IGuiThemesHeaderRef>(null)

    let dragManager = useRef<DragManager | null>(null)
    if(dragManager.current === null) {
        dragManager.current = new DragManager();
    }

    const handleEditRow = (rowIndex: number, dto: GuiSettingsDto) => {
        //dispatch(saveGuiSettings(dto));

        setCurrentGuiSettingDto(dto)
        setShowSettingsPopup(true);
    }

    const handleDeleteRow = (rowIndex: number, dto: GuiSettingsDto) => {
        setShowSettingsPopup(false)
        dispatch(deleteGuiSettings(dto));
    }

    const handleGuiSettingsSave = (dto: GuiSettingsDto, backgroundFile: FileDto | null, logoFile: FileDto | null) => {
        dispatch(saveGuiSettings(dto, flyerDetailsState, backgroundFile, logoFile));
        setShowSettingsPopup(false);
    }

    const handleHide = () => {
        setShowSettingsPopup(false);
        props.onHide()
    }

    const handleNewTheme = () => {
        /*if(guiSettingsState.guiSettings && 
           guiSettingsState.guiSettings.length >= 20) {
            return;
        }*/
        setCurrentGuiSettingDto(new GuiSettingsDto())
        setShowSettingsPopup(true)
    }

    useEffect(() => {
        dispatch(getGuiSettings());
    }, [])

    useEffect(() => {
        setCurrentGuiSettingDto(guiSettingsState.currentGuiSettingsDto)
    }, [guiSettingsState.currentGuiSettingsDto])

    useEffect(() => {
        if(props.show && dragManager.current && contentRef.current &&  headerRef.current){
            dragManager.current.init(contentRef.current!, headerRef.current!)
        }

        return () => {
            if(dragManager.current){
                dragManager.current.dispose();
            }
        }

    }, [props.show, contentRef.current, headerRef.current])

    if (!props.show) {
        return null;
    }

    return (
        <>
            <div className="gui_themes_popup">
                <div 
                    ref={contentRef}
                    className="gui_themes_popup_content_parent">

                    <div>
                        <GuiThemesHeader 
                            ref={headerRef}
                            label="Brands"
                            onClose={handleHide} 
                            />

                        <div className="gui_themes_popup_content">

                            <div
                                className="gui_themese_popup_new_theme_button"
                                onClick={handleNewTheme}
                            >
                                <p>+ New Brand</p>
                            </div>

                            <GuiThemesTable
                                items={guiSettingsState.guiSettings}
                                onEdit={handleEditRow}
                                onDelete={handleDeleteRow}
                            />

                        </div>
                    </div>

                </div>

                <GuiThemeSettingsPopup
                        show={showSettingsPopup}
                        onHide={() => setShowSettingsPopup(false)}
                        dto={{ ...currentGuiSettingDto }}
                        onSave={handleGuiSettingsSave}
                    />

            </div>

        </>
    )
}

export default GuiThemesPopup



